import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { entryForRole } from 'configs/AppConfig';

const AppRoute = ({ component: Component, routeKey, blankLayout, roles, ...props }) => {

	const dispatch = useDispatch()
	const role = useSelector(state => state.auth.user?.role)

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [blankLayout])

	if (roles && roles.length && role && !roles.includes(role)) {
		return <Navigate to={entryForRole(role)} replace />
	}

	return (
		<Component {...props} />
	)
}

export default AppRoute
